export interface OnboardingCitoyenWorkflow {
    Key: string,
    Libelle: string,
    Order: number
}

const ENREGISTREMENT: string = "ENR";
const ETAT_CIVIL: string = "ECV";
const ADRESSE_POSTALE: string = "ADP";
const EXPERIENCE_INVESTISSEMENT :string = "EXI";
const PIECES_JUSTIFICATIVES: string = "PJS";
const REMERCIEMENT: string = "REM"
const TEST_CONNAISSANCES :string ="TCO";
const COMPLET: string = "CPL"

export const OnboardingCitoyenWorkflow = {
    ENREGISTREMENT,
    ETAT_CIVIL,
    ADRESSE_POSTALE,
    EXPERIENCE_INVESTISSEMENT,
    PIECES_JUSTIFICATIVES,
    REMERCIEMENT,
    TEST_CONNAISSANCES,
    COMPLET
}